import { render, staticRenderFns } from "./TwPermitDetailInner.vue?vue&type=template&id=a17e6bcc&scoped=true&"
import script from "./TwPermitDetailInner.vue?vue&type=script&lang=js&"
export * from "./TwPermitDetailInner.vue?vue&type=script&lang=js&"
import style0 from "./TwPermitDetailInner.vue?vue&type=style&index=0&id=a17e6bcc&lang=scss&scoped=true&"
import style1 from "./TwPermitDetailInner.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17e6bcc",
  null
  
)

export default component.exports